import React from 'react'
import { loadCategories, setCategories, setCategoryName } from '../../store/category'
import { connect } from 'react-redux'
import { IndexLink } from 'react-router'
import './Categories.scss'

class CategoriesSelect extends React.Component {

  constructor (props) {
    super(props)

    this.state = {
      categories: this.props.categories,
    }

      this.props.loadCategories()
      this.setCategories = this.props.setCategories
  }

  componentWillReceiveProps (nextProps) {
    this.setState({categories: nextProps.categories})
  }

  handleClick = (id) => {
    this.setCategories(this.state.categories, id)
    this.props.setCategoryName(this.state.categories, id)
  }

  getCategoryName = () => {
    const category = this.state.categories.find(c => c.name === this.props.categoryName)
    if (!category || category.count === 0 || category.parent_id !== null) return "Category"
    return category.name
  } 

  render () {
    return (
      <div className="dropdown category-dropdown  mx-2">
        <button className="btn dropdown-toggle category-btn" 
          type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {this.getCategoryName()}
        </button>
        <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          {this.state.categories.map((i, inx) => {            
            if (i.count === 0) return null
            return (<IndexLink className={'dropdown-item'} key={inx}
              to={i.id ? '/deals/?' + i.url : '/deals'}
              onClick={() => this.handleClick(i.id)}>
                <span className="category-item-name">{i.name.toUpperCase()}</span>
                <span className="category-item-count"> ({i.count})</span>
              </IndexLink>
            )
          })}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    categories: state.categories.filter(c => c.parent_id === null),
    search: state.search,
    categoryName: state.categoryName
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      loadCategories: () => dispatch(loadCategories()),
      setCategories: (categories, cid) => dispatch(setCategories(categories, cid)),
      setCategoryName: (categories, cid) => dispatch(setCategoryName(categories, cid))
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CategoriesSelect)



// WEBPACK FOOTER //
// ./src/components/categories/CategoriesSelect.js